module.exports = __webpack_public_path__ + "static/img/icon3_sel.11c249d0.svg";